import React from 'react';

const Progress = ({ label, progress }) => {

    const width = `${progress}%`;

    return (
        <div className="progress" style={{height: '1.5rem'}}>
            <div aria-valuenow={progress}
                 aria-valuemin="0"
                 aria-valuemax="100"
                 className="progress-bar progress-bar-striped progress-bar--loaded"
                 role="progressbar"
                 style={{width}}>{label}
            </div>
        </div>
    );
};

export default Progress;